/* import __COLOCATED_TEMPLATE__ from './savings-balances.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { SAVINGS_RATE } from '@banking/ui/utils/constants';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { AccountState, Owner, OwnerType } from '@square/dashboard-protos/models/squareup/banking/common';
import { Action, getEvent, Target, Page } from '@banking/ui/utils/budgeting-smart-folders-cdp';
let SavingsBalances = (_dec = service('smart-folder-recommendation'), (_class = class SavingsBalances extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "interestRate", SAVINGS_RATE);
    _initializerDefineProperty(this, "automationSubaccountState", _descriptor, this);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor2, this);
    _initializerDefineProperty(this, "bankingWithholdingConfigApi", _descriptor3, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor4, this);
    _initializerDefineProperty(this, "currentUserData", _descriptor5, this);
    _initializerDefineProperty(this, "dataApi", _descriptor6, this);
    _initializerDefineProperty(this, "smartFolderRecommendationService", _descriptor7, this);
  }
  get showSignup() {
    return this.args.customer && !this.args.customer.primaryAccountId;
  }
  get maskedAccountNumber() {
    const primaryAccount = this.args.balances.find(account => {
      return account.isPrimary;
    });
    if (primaryAccount?.accountNumberSuffix) {
      return `••• •${primaryAccount.accountNumberSuffix}`;
    } else {
      return '';
    }
  }
  get isClosed() {
    return this.args.primaryStatus === AccountState.CLOSED;
  }
  openCreateSubaccountFlow(event) {
    const {
      name,
      properties
    } = getEvent(Action.Click, {
      page: Page.BankingLauncher,
      target: Target.CustomFolder
    });
    this.dataApi.track(name, properties);
    this.args.onOpenCreateFolderFlow();
    event?.target?.deselect();
  }
  closeCreateSubaccountFlow() {
    this.args.onCloseCreateFolderFlow();
    this.automationSubaccountState.resetValues();
  }
  async refreshAccounts() {
    const accounts = await this.bankingAccountApi.listAccounts([Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    })], {
      reload: true
    });
    const accountIds = accounts.map(account => account.id);
    await this.bankingWithholdingConfigApi.list(accountIds);
    if (this.args.hasRecommendedFolders) {
      await this.refreshRecommendedFolders();
    }
  }
  async refreshRecommendedFolders() {
    await this.smartFolderRecommendationService.listRecommendedFolders(Owner.create({
      type: OwnerType.MERCHANT,
      id: this.capitalEngineContext.sessionContext.merchantToken
    }));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "automationSubaccountState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bankingWithholdingConfigApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "smartFolderRecommendationService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "openCreateSubaccountFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openCreateSubaccountFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCreateSubaccountFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCreateSubaccountFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshAccounts", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshAccounts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshRecommendedFolders", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshRecommendedFolders"), _class.prototype)), _class));
export { SavingsBalances as default };